/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export enum REGIONS {
  AQ = 'AQ',
  AT = 'AT',
  CA = 'CA',
  CH = 'CH',
  CZ = 'CZ',
  UK = 'UK',
  DE = 'DE',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  ID = 'ID',
  JP = 'JP',
  KR = 'KR',
  MY = 'MY',
  NL = 'NL',
  NZ = 'NZ',
  PL = 'PL',
  PT = 'PT',
  RO = 'RO',
  SG = 'SG',
  TH = 'TH',
  TW = 'TW',
  US = 'US',
  ZA = 'ZA',
}

export enum LANGUAGES {
  ca = 'ca',
  cs = 'cs',
  uk = 'uk',
  de = 'de',
  en = 'en',
  es = 'es',
  eu = 'eu',
  fr = 'fr',
  gl = 'gl',
  hak = 'hak',
  id = 'id',
  it = 'it',
  ja = 'ja',
  jv = 'jv',
  ko = 'ko',
  ml = 'ml',
  ms = 'ms',
  nan = 'nan',
  nl = 'nl',
  pa = 'pa',
  pl = 'pl',
  pt = 'pt',
  ro = 'ro',
  ta = 'ta',
  te = 'te',
  th = 'th',
  zh = 'zh',
}
